var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_14888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 12.623C12.6203 12.623 13.124 12.1194 13.124 11.498C13.124 10.8767 12.6203 10.373 11.999 10.373C11.3777 10.373 10.874 10.8767 10.874 11.498C10.874 12.1194 11.3777 12.623 11.999 12.623Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87402 12.623C8.49534 12.623 8.99902 12.1194 8.99902 11.498C8.99902 10.8767 8.49534 10.373 7.87402 10.373C7.2527 10.373 6.74902 10.8767 6.74902 11.498C6.74902 12.1194 7.2527 12.623 7.87402 12.623Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.124 12.623C16.7453 12.623 17.249 12.1194 17.249 11.498C17.249 10.8767 16.7453 10.373 16.124 10.373C15.5027 10.373 14.999 10.8767 14.999 11.498C14.999 12.1194 15.5027 12.623 16.124 12.623Z",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49258 19.2895C9.38308 20.3836 11.607 20.7529 13.7496 20.3285C15.8923 19.904 17.8075 18.7148 19.1381 16.9826C20.4687 15.2504 21.124 13.0934 20.9817 10.9138C20.8394 8.7341 19.9093 6.68058 18.3648 5.13605C16.8202 3.59152 14.7667 2.66141 12.5871 2.51913C10.4074 2.37684 8.2504 3.0321 6.51819 4.36272C4.78597 5.69335 3.59679 7.60853 3.17235 9.75119C2.74792 11.8938 3.11719 14.1177 4.21133 16.0082L3.03852 19.5098C2.99445 19.6419 2.98806 19.7838 3.02005 19.9193C3.05205 20.0549 3.12117 20.1789 3.21967 20.2774C3.31817 20.3759 3.44216 20.445 3.57774 20.477C3.71331 20.509 3.85512 20.5026 3.98727 20.4585L7.49258 19.2895Z",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_14888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat.344bcbcdbe0f13ac115fd91b0aa620bb.svg";